<template>
  <div class="page-card">
    <div class="page-head">
      <h3>Follow-up Triage</h3>
    </div>

    <el-form :inline="true" :model="query" size="small" class="search-form">
      <el-form-item label="Keyword">
        <el-input v-model="query.keyword" clearable placeholder="User ID / name / answer / note" @keyup.enter.native="search" />
      </el-form-item>
      <el-form-item label="Status">
        <el-select v-model="query.reviewStatus" clearable placeholder="All">
          <el-option label="R0" value="R0" />
          <el-option label="R1" value="R1" />
          <el-option label="R2" value="R2" />
          <el-option label="R3" value="R3" />
          <el-option label="R4" value="R4" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search">Search</el-button>
        <el-button @click="resetSearch">Reset</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="list" v-loading="loading" border size="small">
      <el-table-column prop="id" label="ID" width="70" />
      <el-table-column label="Athlete" min-width="160" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.athleteName || scope.row.nickname || scope.row.username || '-' }}</template>
      </el-table-column>
      <el-table-column prop="email" label="Email" min-width="180" show-overflow-tooltip />
      <el-table-column prop="scoreType" label="Score" width="90" />
      <el-table-column prop="zoneNumber" label="Zone" width="90" />
      <el-table-column prop="confidenceLevel" label="Confidence" width="120" />
      <el-table-column prop="reviewStatus" label="Status" width="90">
        <template slot-scope="scope"><el-tag :type="statusTag(scope.row.reviewStatus)" size="small">{{ scope.row.reviewStatus }}</el-tag></template>
      </el-table-column>
      <el-table-column prop="statusLabel" label="Meaning" min-width="200" show-overflow-tooltip />
      <el-table-column prop="recommendationPolicy" label="Policy" min-width="180" show-overflow-tooltip />
      <el-table-column prop="createTime" label="Created At" min-width="160" />
      <el-table-column label="Actions" width="100" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="small" class="danger" @click="remove(scope.row)">Delete</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      class="pager"
      background
      layout="total, sizes, prev, pager, next"
      :total="total"
      :page-size="query.pageSize"
      :current-page="query.pageNum"
      :page-sizes="[10, 20, 50, 100]"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import { triageApi } from '@/api/health'

const emptyQuery = () => ({ pageNum: 1, pageSize: 10, keyword: '', reviewStatus: '' })

export default {
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      query: emptyQuery()
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const res = await triageApi.list(this.query)
        const data = res.data || {}
        this.list = data.records || []
        this.total = Number(data.total || 0)
      } finally {
        this.loading = false
      }
    },
    search() {
      this.query.pageNum = 1
      this.loadData()
    },
    resetSearch() {
      this.query = emptyQuery()
      this.loadData()
    },
    handleSizeChange(size) {
      this.query.pageSize = size
      this.query.pageNum = 1
      this.loadData()
    },
    handleCurrentChange(page) {
      this.query.pageNum = page
      this.loadData()
    },
    statusTag(status) {
      if (status === 'R0' || status === 'R1') return 'danger'
      if (status === 'R4') return 'warning'
      if (status === 'R2') return 'success'
      return 'info'
    },
    async remove(row) {
      await this.$confirm(`Delete triage record #${row.id}?`, 'Confirm', { type: 'warning' })
      await triageApi.remove(row.id)
      this.$message.success('Deleted successfully')
      this.loadData()
    }
  }
}
</script>

<style scoped>
.page-head { display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px; }
.page-head h3 { margin: 0; }
.search-form { margin-bottom: 12px; }
.pager { margin-top: 16px; text-align: right; }
.danger { color: #f56c6c; }
</style>
